<template>
  <div class="flex flex-col min-h-full">
    <div class="lerner-header-container" :class="{collapsed: navCollapsed}">
      <student-header v-on:adminLinkClicked="showAdminLoginModal"></student-header>
      <category-navigation
          :key="$route.fullPath"
          :categories="categories">
      </category-navigation>
    </div>
    <section class="flex-auto">
      <router-view></router-view>
    </section>
    <student-footer></student-footer>
    <modal v-if="showModal" @close="closeModal" title="Back To Admin">
      <div slot="header">
        <loading-indicator v-if="authPending" class="loading-indicator"></loading-indicator>
      </div>
      <admin-login-form
          slot="body"
          :user="currentUser"
          :pending="authPending"
          :auth-errors="authErrors"
          v-on:submit="submit"
      />
    </modal>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import StudentHeader from './StudentHeader';
  import { CategoriesLoaded } from '@/common/guards/categoriesLoaded.guard';
  import Modal from '@/component/Modal';
  import { BACK_TO_ADMIN } from '@/store/actions/auth.actions';
  import AdminLoginForm from '@/views/Student/AdminLoginForm';
  import LoadingIndicator from '@/component/LoadingIndicator';
  import CategoryNavigation from '@/views/Student/CategoryNavigation';
  import StudentFooter from '@/views/Student/StudentFooter';

  export default {
    name: 'index',

    components: {
      StudentFooter,
      CategoryNavigation,
      LoadingIndicator,
      AdminLoginForm,
      CategoriesLoaded,
      StudentHeader,
      Modal
    },

    data: function () {
      return {
        showModal: false
      }
    },

    computed: {
      ...mapGetters(['categories', 'category', 'currentUser', 'authErrors', 'authPending', 'navCollapsed']),
    },

    methods: {
      showAdminLoginModal: function () {
        this.password = null;
        this.showModal = true;
      },

      closeModal: function () {
        this.showModal = false;
      },

      submit: function ({email, password}) {
        this.$store
            .dispatch(BACK_TO_ADMIN, {email, password})
            .then(() => {
              this.showModal = false;
              this.$router.push({name: 'admin'});
            });
      }
    },

    beforeRouteEnter(to, from, next) {
      CategoriesLoaded(to, from, next)
    },
  }
</script>

<style lang="scss" scoped>
  .lerner-header-container {
    @apply bg-white fixed z-50;
    box-shadow: 0 8px 14px -10px #000;
    width: calc(100% - config('padding.6'));
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    transition: top .25s ease;

    @media (min-width: config('screens.md')) {
      width: calc(config('staticWidth.container.md') - config('padding.6'));
    }

    @media (min-width: config('screens.lg')) {
      width: calc(config('staticWidth.container.lg') - config('padding.6'));
    }

    @media (min-width: config('screens.xl')) {
      width: calc(config('staticWidth.container.xl') - config('padding.6'));
    }

    &.collapsed {
      top: -200px;

      @media (min-width: config('screens.lg')) {
        top: -216px;
      }
    }
  }

  .loading-indicator {
    @apply absolute pin-l;
    top: 64px;
  }
</style>
